import { MultiValuedListMoreItem } from '../../MultiValuedList'
import { FileMultiValue } from '../FileMultiValue'

import * as styles from './FileMultiValuedListMoreItem.module.css'

function FileMultiValuedListMoreItem({
  additionalTooltipInfo,
  item,
  onClick,
  ...itemProps
}) {
  return (
    <MultiValuedListMoreItem {...itemProps}>
      <FileMultiValue
        additionalTooltipInfo={additionalTooltipInfo}
        item={item}
        textClassName={styles.text}
        onClick={onClick}
      />
    </MultiValuedListMoreItem>
  )
}

export default FileMultiValuedListMoreItem
